import { render, staticRenderFns } from "./Persona_editar.vue?vue&type=template&id=86309238&scoped=true"
import script from "./Persona_editar.vue?vue&type=script&lang=js"
export * from "./Persona_editar.vue?vue&type=script&lang=js"
import style0 from "./Persona_editar.vue?vue&type=style&index=0&id=86309238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86309238",
  null
  
)

export default component.exports